import { NgModule } from '@angular/core';

// TODO: if module is too large, create angular modules in each section, and expose those.
// TODO: also look into size fixing with respect to the google lib phonenumber library
import { ArrayToCommaPipe } from './array/array-to-comma-pipe';

import { AsidePipe } from './default-values/aside-pipe';
import { DefaultValuePipe } from './default-values/default-value-pipe';
import { ZeroEmptyPipe } from './default-values/zero-empty-pipe';


import { RawPipe } from './html/raw-pipe';
import { SafePipe } from './html/safe-pipe';

import { MacAddressizePipe } from './mac-address/mac-addressize-pipe';

import { BytesPipe } from './number/bytes-pipe';
import { MbpsPipe } from './number/mbps.pipe';

import { PropertiesToObjectPipe } from './object/properties-to-object-pipe';

import { NumberizePipe } from './phone-number/numberize-pipe';

import { StripJsonPipe } from './string/strip-json-pipe';
import { TitleizePipe } from './string/titleize-pipe';
import { TruncatePipe } from './string/truncate-pipe';


import { DateizePipe } from './time/dateize-pipe';
import { DurationPipe } from './time/duration-pipe';
import { HourRangePipe } from './time/hour-range-pipe';
import { MomentLocalZonePipe, MomentDatePipe } from './time/momentLocalZone-pipe.';
import { MsPipe } from './time/ms-pipe';
import { TimeAgoPipe } from './time/time-ago-pipe';
import { UppercasePipe } from './string/uppercase-pipe';
import { DurationStringPipe } from './time/durationString-pipe';
import { MinusToParensPipe } from './number/minus-to-parens.pipe';
import { AmPmPipe } from './time/am-pm-pipe';
import { TimezoneOffsetPipe } from './time/timezone-offset-pipe';
import { DateTzPipe } from './time/dateTz-pipe';
import { DatePipe } from '@angular/common';

import { RegionNamePipe } from './intl/region-name.pipe';
import { LanguageNamePipe } from './intl/language-name.pipe';

export {
  ArrayToCommaPipe,
  AsidePipe,
  DefaultValuePipe,
  ZeroEmptyPipe,
  RawPipe,
  SafePipe,
  MacAddressizePipe,
  BytesPipe,
  MbpsPipe,
  PropertiesToObjectPipe,
  NumberizePipe,
  StripJsonPipe,
  TitleizePipe,
  UppercasePipe,
  TruncatePipe,
  DateizePipe,
  DurationPipe,
  DurationStringPipe,
  HourRangePipe,
  MomentLocalZonePipe,
  MomentDatePipe,
  MsPipe,
  TimeAgoPipe,
  AmPmPipe,
  TimezoneOffsetPipe,
  DateTzPipe,
  RegionNamePipe,
  LanguageNamePipe,
};

@NgModule({
  exports: [
    ArrayToCommaPipe,
    AsidePipe,
    DefaultValuePipe,
    ZeroEmptyPipe,
    RawPipe,
    SafePipe,
    MacAddressizePipe,
    BytesPipe,
    MbpsPipe,
    PropertiesToObjectPipe,
    NumberizePipe,
    StripJsonPipe,
    TitleizePipe,
    UppercasePipe,
    TruncatePipe,
    DateizePipe,
    DurationPipe,
    MsPipe,
    DurationStringPipe,
    HourRangePipe,
    MomentLocalZonePipe,
    MomentDatePipe,
    TimeAgoPipe,
    MinusToParensPipe,
    AmPmPipe,
    TimezoneOffsetPipe,
    DateTzPipe,
    RegionNamePipe,
    LanguageNamePipe,
  ],
  declarations: [
    ArrayToCommaPipe,
    AsidePipe,
    DefaultValuePipe,
    ZeroEmptyPipe,
    RawPipe,
    SafePipe,
    MacAddressizePipe,
    BytesPipe,
    MbpsPipe,
    PropertiesToObjectPipe,
    NumberizePipe,
    StripJsonPipe,
    TitleizePipe,
    UppercasePipe,
    TruncatePipe,
    DateizePipe,
    DurationPipe,
    DurationStringPipe,
    HourRangePipe,
    MomentLocalZonePipe,
    MomentDatePipe,
    MsPipe,
    TimeAgoPipe,
    MinusToParensPipe,
    AmPmPipe,
    TimezoneOffsetPipe,
    DateTzPipe,
    RegionNamePipe,
    LanguageNamePipe,
  ],
  providers: [
    NumberizePipe,
    MacAddressizePipe,
    TitleizePipe,
    DurationPipe,
    DatePipe,
  ]
})
export class CommonPipesModule {}
